import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Params, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AbilityService } from 'ability';
import { RoutingPath } from 'mbs-ui-shared@constants/app-routing-path.enum';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { Observable, map, take } from 'rxjs';

export const BackupHistory2024Fn: CanActivateChildFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> => {
  const auth = inject(AuthFacade);
  const ability = inject(AbilityService);
  const router = inject(Router);

  return auth.currentUser$.pipe(
    take(1),
    map((user) => {
      if (!user) {
        return false;
      }

      if (ability.can('read', 'BackupHistory2024')) {
        const commands: string[] = [RoutingPath.ApNewBackupHistory];

        next.url.length && commands.push(next.url[0].path);

        return router.createUrlTree(commands, { queryParams: next.queryParams });
      } else {
        const commands: string[] = [RoutingPath.ApBackupHistoryLegacy];
        const queryParams: Params = {};
        let hid: string = null;

        next.url.length && (hid = next.url[0].path);
        next.queryParams?.search && (hid = next.queryParams.search);
        hid && (queryParams.filter = `hid:${hid}`);
        next.queryParams?.companies && commands.push(next.queryParams.companies);

        if (next.queryParams?.plan && next.queryParams?.sidepanel && next.queryParams?.date && hid) {
          queryParams.openPlanDetail = true;
          queryParams.hid = hid;
          queryParams.id = next.queryParams.plan;
        }

        return router.createUrlTree(commands, { queryParams });
      }
    })
  );
};
